module.exports = __webpack_public_path__ + "img/陈宇雷.5b49ccfb.png";